import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  loggedInStatus;
  userRole;
  blogURL: string;
  mediaURL: string;
  techDomainData: any;
  wpAutoLoginUrl: string = '';
  appleStoreUrl: string = '';
  playStoreUrl: string = '';
  enableStoreIcons: boolean;
  selectedTechDomainId: string;
  constructor(private authenticationService: AuthenticationService,
    private router: Router,
    private rolesSharedService: RolesSharedService
  ) { }

  ngOnInit() {
    this.blogURL = environment.BLOG_URL;
    this.mediaURL = environment.MEDIA;
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.appleStoreUrl = environment.APPLE_STORE_URL;
    this.playStoreUrl = environment.PLAY_STORE_URL;
    this.enableStoreIcons = environment.ENABLE_APP_STORE_ICONS;

    this.getRole();
    this.getTechDomainList();

    this.selectedTechDomainId = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : '';
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  navRouteToHome() {
    this.router.navigate([''])
  }

  navRouteToBlogs() {
    let token = this.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}`;
      window.open(blogUrl, '_self');
    } else {
      window.open(this.blogURL, '_self');
    }
  }

  techDomainChanged(techDomain) {
    this.selectedTechDomainId = techDomain.id;
    window.localStorage.setItem('selectedTechDomainId', this.selectedTechDomainId);
  }

  navRouteToMedia() {
    const token = this.getToken();
    if (token) {
      const mediaURL = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=media`;
      window.open(mediaURL, '_self');
    } else {
      window.open(this.mediaURL, '_self');
    }
  }
  navRouteToTechDomains() {
    this.router.navigate([`tech-domain-list`]);
  }
  analystListNavigate() {
    this.router.navigate([`${this.userRole}/analyst-list`]);
  }

  contactNavigation() {
    this.router.navigate([`contact-us`]);
  }
  supportNavigation() {
    this.router.navigate([`support`]);
  }
  termsOpen() {
    window.open("/#/terms-of-use", "Terms & Conditions");
  }

  goToPlaystore() {
    window.open(this.playStoreUrl);
  }

  goToAppStore() {
    window.open(this.appleStoreUrl);
  }

  privacyOpen() {
    window.open("/#/privacy-policy ", "Privacy Policy");
  }
  aboutNavigation() {
    this.router.navigate([`about-us`]);
  }
  getTechDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe((techDomainResponse: any) => {
      this.techDomainData = techDomainResponse;
    });
  }
  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'))
    if (userData) {
      token = userData.accessToken;
    } else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/footer/footer.component.ts